var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mz-mask-in-game",style:({
    position: _vm.itemData.position || 'absolute',
    top: _vm.itemData.pos.y + _vm.itemData.unit || '%',
    left: _vm.itemData.pos.x + _vm.itemData.unit || '%',
    background: _vm.itemData.background || 'transparent',
    width: _vm.itemData.width || '0',
    height: _vm.itemData.height || '0',
  })},[(_vm.wrapState)?_c('img',{staticClass:"wrap-image",style:(_vm.wrapStyle),attrs:{"draggable":"false","src":_vm.wrap},on:{"click":function($event){return _vm.uncoverWhatIsHidden()}}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }